<template>
  <div v-if="$can('edit concierge advisers schedules')" class="form-inline mb-3">
    <label class="my-1 mr-2 w-auto fw-600" for="mondayPicker">
      {{ $t('models/conciergeAdviserSchedulePeriods.monday_picker.label') }}
    </label>

    <div class="my-1 mr-sm-2 d-inline-block w-auto">
      <VueDatePicker
        v-model="mondayForm.date"
        :enable-time-picker="false"
        auto-apply
        :locale="locale"
        timezone="GMT"
        format="dd/MM/yyyy"
        :disabled-week-days="[2, 3, 4, 5, 6, 0]"
        style="place-content: center"
        @date-update="validateMonday"
      />
    </div>

    <button
      type="submit"
      @click="submit()"
      class="btn btn-success btn-sm my-1"
      :disabled="disabled || mondayForm.processing"
    >
      {{ $t('crud.apply') }}
      <i v-if="mondayForm.processing" class="fa fa-spinner fa-spin"></i>
    </button>
    <div v-if="errorMessage" class="invalid-feedback d-block">
      {{ errorMessage }}
    </div>
    <div v-if="warningMessage" class="invalid-feedback text-orange d-block">
      {{ warningMessage }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useForm, usePage } from '@inertiajs/vue3'
import { wTrans } from 'laravel-vue-i18n'
import { ref, computed } from 'vue'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

const locale = computed<string>(() => {
  const locales = new Map([
    ['fr', 'fr-CA'],
    ['en', 'en-CA']
  ])
  return locales.get(usePage().props.locale) ?? 'fr-CA'
})
const errorMessage = ref<string>('')
const warningMessage = ref<string>('')
const disabled = ref<boolean>(true)
const mondayForm = useForm({
  date: ''
})

const props = defineProps<{
  date: string
  adviserId: number
}>()

if (props.date) {
  mondayForm.date = props.date
}
const validateMonday = (date: Date) => {
  if (date instanceof Date) {
    const isMonday = date.getDay() == 1
    const today = new Date()
    const isFuture = date > today
    if (!isMonday) {
      errorMessage.value = wTrans(
        'models/conciergeAdviserSchedulePeriods.monday_picker.error_message'
      ).value
    } else if (isFuture) {
      warningMessage.value = wTrans(
        'models/conciergeAdviserSchedulePeriods.monday_picker.future_date_warning_message'
      ).value
      disabled.value = false
    } else {
      errorMessage.value = ''
      warningMessage.value = ''
      disabled.value = false
    }
  }
}

const submit = () => {
  mondayForm.patch(route('conciergeAdvisers.schedules.updateStartOnDate', [props.adviserId]), {
    onSuccess: () => {
      disabled.value = true
      errorMessage.value = ''
      warningMessage.value = ''
    },
    onError: errors => {
      console.error(errors)
      errorMessage.value = errors.message || 'An error occurred while updating the monday date'
    }
  })
}
</script>
<style>
:root {
  --dp-input-padding: 2px;
}
</style>
